import React from 'react';
import { flCapital } from './helpers/Utils';

const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'));

const CanadaPolitical = React.lazy(() => import('./views/political/canada/CanadaPolitical'));

const CanadaProvincialPolitical = React.lazy(() => import('./views/political/canada/CanadaProvincialPolitical'));

const CanadianProvincialElections = React.lazy(() => import('./views/political/canada/provincial/CanadianProvincialElections'));
const CanadianProvincialElection = React.lazy(() => import('./views/political/canada/provincial/CanadianProvincialElection'));
const CanadianProvincialRedirect = React.lazy(() => import('./views/political/canada/provincial/CanadianProvincialRedirect'));

const CanadianProvincialLeadershipElections = React.lazy(() => import('./views/political/canada/provincial/leadership/CanadianProvincialLeaderships'));
const CanadianProvincialLeadershipElection = React.lazy(() => import('./views/political/canada/provincial/leadership/CanadianProvincialLeadership'));
const CanadianProvincialLeadershipRedirect = React.lazy(() => import('./views/political/canada/provincial/leadership/CanadianProvincialLeadershipRedirect'));
const ProvincialLeadershipPollMap = React.lazy(() => import('./views/political/canada/provincial/leadership/ProvincialLeadershipPollMap'));

const CanadianFederalElections = React.lazy(() => import('./views/political/canada/federal/CanadianFederalElections'));
const CanadianFederalElection = React.lazy(() => import('./views/political/canada/federal/CanadianFederalElection'));
const CanadianFederal = React.lazy(() => import('./views/political/canada/federal/CanadianFederal'));
const CanadianFederalFresh = React.lazy(() => import('./views/political/canada/federal/CanadianFederalFresh'));
const FederalPollMap = React.lazy(() => import('./views/political/canada/federal/FederalPollMap'));
const ProvincialPollMap = React.lazy(() => import('./views/political/canada/provincial/ProvincialPollMap'));

const CanadianFederalLeaderships = React.lazy(() => import('./views/political/canada/federal/leadership/CanadianFederalLeaderships'));
const CanadianFederalLeadershipsParty = React.lazy(() => import('./views/political/canada/federal/leadership/CanadianFederalLeadershipsParty'));
const CanadianFederalLeadership = React.lazy(() => import('./views/political/canada/federal/leadership/CanadianFederalLeadership'));

export const getRoutes = (a) => {

  var theRoutes = [
    
  { path: '/', exact: true, name: 'Home', component: Dashboard },

  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  
  { path: '/political/canada/federal/election/:year/:local_division?', name: 'Poll-by-poll', component: FederalPollMap },  
  { path: '/political/canada/federal/election/', name: 'Election', component: CanadianFederalElections },  
  { path: '/political/canada/federal/elections/federalmap', name: 'Map Maker', component: CanadianFederal },  
  { path: '/political/canada/federal/elections/federalmapfresh', name: 'Map Maker Fresh', component: CanadianFederalFresh },  
  { path: '/political/canada/federal/elections/', name: 'Elections', component: CanadianFederalElections },  
  { path: '/political/canada/federal/leaderships/:party/:year', name: 'Map', component: CanadianFederalLeadership },  
  { path: '/political/canada/federal/leaderships/:party', name: 'Party', component: CanadianFederalLeadershipsParty },  
  { path: '/political/canada/federal/leaderships/', name: 'Leaderships', component: CanadianFederalLeaderships },  
  { path: '/political/canada/provincial/election/:minor_jurisdiction/:year/:local_division?', name: 'Poll-by-poll', component: ProvincialPollMap },                 
  { path: '/political/canada/provincial/election/:minor_jurisdiction', name: flCapital(a), component: CanadianProvincialRedirect },                       
  { path: '/political/canada/provincial/election', name: null, component: CanadianProvincialElection },
  { path: '/political/canada/provincial/elections/:minor_jurisdiction', name: flCapital(a), component: CanadianProvincialElections },        
  { path: '/political/canada/provincial/leadership/:minor_jurisdiction/:year/:local_division?', name: 'Poll-by-poll', component: ProvincialLeadershipPollMap },                 
  { path: '/political/canada/provincial/leadership/:minor_jurisdiction', name: flCapital(a), component: CanadianProvincialLeadershipRedirect },                       
  { path: '/political/canada/provincial/leadership', name: null, component: CanadianProvincialLeadershipElection },    
  { path: '/political/canada/provincial', name: 'Provincial', component: CanadaProvincialPolitical },      
  { path: '/political/canada/federal', name: 'Federal', component: CanadaPolitical },    
  { path: '/political/canada/', name: 'Canada', component: CanadaPolitical },    
  { path: '/political/', name: 'Political', component: CanadaPolitical },


    // { path: '/political/canada/federal/elections/:year/:local_division', name: 'Federal Poll Map', component: CanadianFederalElections1 },  
  // { path: '/political/canada/federal/elections/:year/', name: 'Federal Election', component: CanadianFederalElections1 },  
  // { path: '/political/canada/federal/elections/', name: 'Canadian Federal Elections', component: CanadianFederalElections1 },    
  
];

  return theRoutes;
}
